module.exports = __webpack_public_path__ + "media/img/pages/profile/kpmg ger 13-9e9795d54cfac673d77143a803156bb5.jpg";